import React from 'react';
import { useStyletron } from 'baseui';
import _get from 'lodash/get';

import ConfirmationModal from '../ConfirmationModal';
import Loader from '../Loader';

import Form from './Form';
import FormFooter from './FormFooter';
import useFormBuilder from './useFormBuilder';
import { IFormBuilder } from './types';

const FormBuilder: React.FC<IFormBuilder> = (props) => {
	const { buttonLabels } = props;
	const {
		fieldConfig,
		layoutConfig,
		alert,
		control,
		errors,
		mode,
		showLoader,
		watch,
		onSubmit,
		handleSubmit,
		handleCancelClick,
		handleAlertConfirmation,
		handleAlertCancel,
		setShowLoader,
		setValue,
		initialValues
	} = useFormBuilder(props);

	const [css] = useStyletron();

	return (
		<div className={css({ height: '100%', overflow: 'auto' })}>
			{showLoader && <Loader />}
			{alert.show && (
				<ConfirmationModal
					confirmationMessage={alert.message}
					agreeLabel='Submit'
					closeLabel='Go Back'
					onClose={handleAlertCancel}
					confirmationDialogOnAgree={handleAlertConfirmation}
				/>
			)}
			<form onSubmit={handleSubmit(onSubmit)} className={css({ margin: '10px 100px 10px 100px', paddingBottom: '20px' })}>
				<Form
					fieldConfig={fieldConfig}
					layoutConfig={layoutConfig}
					control={control}
					errors={errors}
					mode={mode}
					watch={watch}
					setValue={setValue}
					setShowLoader={setShowLoader}
					initialValues={initialValues}
				/>
				<FormFooter
					mode={mode}
					primaryButtonLabel={_get(buttonLabels, ['submitLabel'], 'Submit')}
					secondaryButtonLabel={_get(buttonLabels, ['discardLabel'], 'Discard')}
					secondaryClickHandler={handleCancelClick}
				/>
			</form>
		</div>
	);
};

export default FormBuilder;
